var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChevronThick = function SvgChevronThick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24h24V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "M5.437 14.671a1.5 1.5 0 1 1-1.874-2.342l7.5-6a1.5 1.5 0 0 1 1.874 0l7.5 6a1.5 1.5 0 0 1-1.874 2.342L12 9.421l-6.563 5.25z"
  }))));
};

export { SvgChevronThick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMCAyNGgyNFYwSDB6Ii8+PHBhdGggZmlsbD0iIzMzMyIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJNNS40MzcgMTQuNjcxYTEuNSAxLjUgMCAxIDEtMS44NzQtMi4zNDJsNy41LTZhMS41IDEuNSAwIDAgMSAxLjg3NCAwbDcuNSA2YTEuNSAxLjUgMCAwIDEtMS44NzQgMi4zNDJMMTIgOS40MjFsLTYuNTYzIDUuMjV6Ii8+PC9nPjwvc3ZnPg==";